import { FC, createContext } from 'react';
import { types, Instance } from 'mobx-state-tree';
import { useLocalObservable } from 'mobx-react-lite';
import { MyFC } from '@/types/common';
import { MainStore } from '@stores/main/main.store';
import { AuthStore } from '@stores/auth/auth.store';
import { AlertStore } from '@stores/alert/alert.store';
import { ProfileStore } from '@stores/profile/profile.store';
import { BrandsStore } from '@stores/brands/brands.store';
import { PopupStore } from '@stores/popup/popup.store';
import { PointsStore } from '@stores/points/points.store';
import { HeremapsStore } from '@stores/heremaps/heremaps.store';
import { ProductsStore } from '@stores/products/products.store';
import { DEFAULT_ALERT_TIMOUT } from '@stores/alert/constants';
import { CataloguesStore } from './catalogues/catalogues.store';

const { model } = types;

export const RootStore = model('RootStore', {
  mainStore: MainStore,
  alertStore: AlertStore,
  authStore: AuthStore,
  profileStore: ProfileStore,
  brandsStore: BrandsStore,
  popupStore: PopupStore,
  pointsStore: PointsStore,
  heremapsStore: HeremapsStore,
  productsStore: ProductsStore,
  cataloguesStore: CataloguesStore,
  // popUpStore: PopUpStore,
  // tableStore: TableStore,
  // usersStore: UsersStore,
  // requestsStore: RequestsStore,
  // discountsStore: DiscountsStore,
});

export type IRootStore = Instance<typeof RootStore>;

export const RootStoreContext = createContext<IRootStore | null>(null);

export const RootStoreProvider: MyFC = ({ children }) => {
  const store = useLocalObservable(() =>
    RootStore.create({
      mainStore: { globalLoading: false, theme: 'light' },
      authStore: {
        authStep: 'creds',
        authData: { email: 'example@mail.com' },
      },
      profileStore: {},
      alertStore: {
        message: '',
        show: false,
        type: 'error',
        timeout: DEFAULT_ALERT_TIMOUT,
      },
      brandsStore: {},
      popupStore: { open: false },
      pointsStore: {
        shouldUpdatePointsCategories: true,
      },
      heremapsStore: {},
      productsStore: {},
      cataloguesStore: {},
    })
  );
  return <RootStoreContext.Provider value={store}>{children}</RootStoreContext.Provider>;
};
